import type { PropsWithChildren } from 'react';
import { Link } from '@app/_components/link';
import { css } from '@styled-system/css';
import { VStack, HStack, Box, VstackProps } from '@styled-system/jsx';
import linkArrow from './assets/link-arrow-blue.svg';

export interface DetailLink {
  title: string;
  link: string;
  buttonLink?: boolean;
}

type Props = PropsWithChildren<
  {
    title: string;
    detailLink?: DetailLink;
  } & VstackProps
>;

export const AsideBlock = ({
  title,
  detailLink,
  children,
  ...vstackProps
}: Props) => {
  return (
    <VStack
      className={css({
        background: 'primary',
        padding: {
          base: '20px 0 20px 16px',
          lg: '16px 24px',
        },
        borderRadius: {
          base: '0',
          lg: '8px',
        },
        maxWidth: '100vw',
        width: '100%',
        overflowX: 'hidden',
        _hover: {
          '&  button': {
            opacity: '1',
          },
        },
      })}
      {...vstackProps}
    >
      <h2 className={css({ width: '100%' })}>
        <HStack justifyContent="space-between" alignItems="baseline">
          <span
            className={css({
              fontSize: {
                base: 'size_18',
                lg: 'size_14',
              },
              fontWeight: '700',
            })}
          >
            {title}
          </span>
          {detailLink && (
            <>
              {detailLink.buttonLink ? (
                <Link href={detailLink.link}>
                  <Box
                    display="inline-block"
                    marginRight={{ base: '8px', lg: '0' }}
                    flex="0 0 auto"
                    padding="4px 16px"
                    borderRadius="2em"
                    backgroundColor="strong_bg"
                    _hover={{
                      opacity: 0.7,
                    }}
                  >
                    <span
                      className={css({
                        color: 'accent.1000',
                        fontSize: 'size_14',
                        fontWeight: 'bold',
                      })}
                    >
                      {detailLink.title}
                    </span>
                  </Box>
                </Link>
              ) : (
                <Link
                  className={css({
                    color: 'tint',
                    fontSize: { base: 'size_12', lg: 'size_14' },
                    fontWeight: '700',
                  })}
                  href={detailLink.link}
                >
                  {detailLink.title}
                  <img
                    src={linkArrow}
                    className={css({
                      display: 'inline-block',
                      width: '20px',
                      height: '20px',
                      marginTop: '-2px',
                    })}
                    alt="すべて見る"
                  />
                </Link>
              )}
            </>
          )}
        </HStack>
      </h2>

      {children}
    </VStack>
  );
};
